<template>
  <section class="ip-block__content">
    <header class="content__header">
      <h2 v-html="$t('userInfo.lnb.ipBlocking')"></h2>
    </header>
    <div v-if="!domains.list || !domains.list.length" class="content__body no-register-page">
      <ui-loading-circle></ui-loading-circle>
    </div>
    <div v-else class="content__body" ref="scrollContent">
      <content-box class="content__target-domain" :width="'800px'">
        <div class="form--wrap">
          <p class="title"
             v-if="userData.updatePermission"
             v-html="$t('userInfo.ipBlocking.selectDomain.title')"></p>
          <p class="title"
             v-else
             v-html="$t('userInfo.ipBlocking.selectDomain2.title')"></p>
          <div class="domain--wrap">
            <label class="label" for="targetDomain" v-html="$t('common.domain')"></label>
            <UiSelectbox
              id="targetDomain"
              @input="onSelectedDomain"
              :useRawText="true"
              :value="domains.selectedValue"
              :items="domains.list" />
          </div>
        </div>
        <div class="form--wrap">
          <p class="title"
             v-if="userData.updatePermission"
             v-html="$t('userInfo.ipBlocking.selectCountryCode.title')"></p>
          <p class="title"
             v-else
             v-html="$t(`userInfo.ipBlocking.selectCountryCode2.title`)"></p>
          <div class="domain--wrap">
            <label class="label" for="targetCountryCode" v-html="$t('common.countryCode')"></label>
            <UiSelectbox
              v-if="domains.siteCodeList[domains.selectedIndex].length"
              id="targetCountryCode"
              @input="onSelectedCountryCode"
              :useRawText="true"
              :value="domains.currentSiteCode"
              :items="domains.siteCodeList[domains.selectedIndex]" />
            <div v-else>-</div>
          </div>
        </div>
      </content-box>
      <content-box class="content__target-ip" :width="'800px'">
        <div class="content__top" v-if="userData.updatePermission">
          <p class="title" v-html="$t('userInfo.ipBlocking.enterIp.title')"></p>
          <div class="input--wrap">
            <p class="desc" v-html="$t('userInfo.ipBlocking.enterIp.desc')"></p>
            <div class="ip-info-box">
              <div class="ip-name">
                <label class="label" for="ipName" v-html="$t('common.ipName')"></label>
                <input type="text"
                       id="ipName"
                       :placeholder="$t('common.placeHolder.enterIpName')"
                       v-model.trim="model.name"
                       @focus="modelError.name = ''"
                       :class="{error: modelError.name}">
                <i v-if="model.name.length" class="icon icon--close14" @click="model.name = ''"></i>
                <strong v-if="modelError.name" class="validation-text"
                  v-html="$t(`common.validationErrorText.ipBlock.${modelError.name}`)"></strong>
              </div>
              <div class="ip-address">
                <label class="label" for="ipAddress" v-html="$t('common.ipAddress')"></label>
                <input type="text" id="ipAddress"
                  :placeholder="$t('common.placeHolder.ipAddress')"
                  v-model.trim="model.ip"
                  @focus="modelError.ip = ''"
                  :class="{error: modelError.ip}">
                <i v-if="model.ip.length" class="icon icon--close14" @click="model.ip = ''"></i>
                <strong v-if="modelError.ip" class="validation-text"
                  v-html="$t(`common.validationErrorText.ipBlock.${modelError.ip}`)"></strong>
              </div>
            </div>
          </div>
          <div class="button--wrap">
            <ui-button class="btn__add-my-ip"
                       :iconName="'icon--plus-black'"
                       :noBorder="true"
                       @click="onAddMyIp">{{ $t('userInfo.ipBlocking.addMyIp') }}</ui-button>
            <ui-button class="btn__block"
                       :primary2="true"
                       @click="onAddIpListItem">{{ $t('userInfo.ipBlocking.block') }}</ui-button>
          </div>
        </div>
        <!-- table -->
        <div class="content__bottom">
          <table>
            <colgroup>
              <col width="*">
              <col :width="userData.updatePermission ? 232 : 282">
              <col width="138" v-if="userData.updatePermission">
            </colgroup>
            <thead>
              <tr>
                <th>{{ $t('common.table.header.ipName') }}</th>
                <th>{{ $t('common.table.header.ipAddress') }}</th>
                <th v-if="userData.updatePermission"></th>
              </tr>
            </thead>
            <tbody v-if="ipList">
              <ip-block-item
                v-for="(item, index) in ipList"
                :key="index"
                :item="item"
                :ipList="ipList"
                @removeListItem="onRemoveIpListItem"
                @editListItem="onEditListItem"/>
            </tbody>
            <tbody v-else-if="isReady">
            <tr class="no-ip-list">
              <td rowspan="2" colspan="3" v-html="$t('userInfo.ipBlocking.noRegisteredIp')"></td>
            </tr>
            <tr>
            </tr>
            </tbody>
          </table>
        </div>
      </content-box>
      <back-to-top :refName="'scrollContent'" />
    </div>
  </section>
</template>

<script>
import { getDomains } from '@/api/apply'
import { myIp, getIpList, insertIp, removeIp, updateIp } from '@/api/ipblock'
import { isValidIpAddress } from '@/libs/validation-helper'
import ContentBox from '@/components/ui/ContentBox'
import UiSelectbox from '@/components/ui/UiSelectbox'
import BackToTop from '@/components/ui/BackToTop'
import UiButton from '@/components/ui/UiButton'
import ipBlockItem from '@/components/user-info/ipblock/IpBlockItem'
import AppDialog from '@/components/ui/AppDialog'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import { create } from 'vue-modal-dialogs'
import { mapState } from 'vuex'

const openDialog = create(AppDialog, 'dialogType')

export default {
  components: {
    ContentBox,
    UiSelectbox,
    BackToTop,
    UiButton,
    UiLoadingCircle,
    ipBlockItem
  },
  computed: {
    ...mapState([
      'userData'
    ])
  },
  data () {
    return {
      model: {
        name: '',
        ip: ''
      },
      modelError: {
        name: '',
        ip: ''
      },
      domains: {
        list: [],
        sid: [],
        siteCodeList: [],
        selectedValue: '',
        selectedIndex: null,
        currentSiteCode: '',
        currentDomainSid: ''
      },
      ipList: null,
      isReady: false
    }
  },
  methods: {
    getDomains () {
      this.isReady = false
      getDomains().then(items => {
        items = items.filter(item => item.shared !== true)
        this.domains.list = items.map(item => item.domain)
        this.domains.sid = items.map(item => item.sid)
        this.domains.siteCodeList = items.map(item => item.site_code)
        this.domains.selectedValue = this.domains.list[0]
        this.onSelectedDomain(this.domains.selectedValue)
        this.isReady = true
      })
    },
    onSelectedDomain (value) {
      this.modelError.name = ''
      this.modelError.ip = ''
      this.domains.selectedValue = value
      this.domains.list.forEach((item, index) => {
        if (item === value) {
          this.domains.selectedIndex = index
          this.domains.currentDomainSid = this.domains.sid[index]
          if (this.domains.siteCodeList[index].length) {
            this.onSelectedCountryCode(this.domains.siteCodeList[index][0])
          } else {
            this.onSelectedCountryCode(null)
          }
        }
      })
    },
    onSelectedCountryCode (value) {
      this.modelError.name = ''
      this.modelError.ip = ''
      this.domains.currentSiteCode = value
      this.getDomainIpList()
    },
    getDomainIpList () {
      let param = {
        sid: this.domains.currentDomainSid,
        siteCode: this.domains.currentSiteCode
      }
      getIpList(param).then(response => {
        let ipList = []
        response['ip'].forEach((item) => {
          item['edit'] = false
          ipList.push(item)
        })
        this.ipList = ipList
      }).catch(() => {
        this.ipList = null
      })
    },
    onAddMyIp () {
      this.model.name = this.$t('userInfo.ipBlocking.myIp')
      this.modelError.name = ''
      myIp().then(response => {
        this.model.ip = response
        this.modelError.ip = ''
      })
    },
    onAddIpListItem () {
      if (!this.model.name) {
        this.modelError.name = 'requiredIpName'
      }
      if (!this.model.ip) {
        this.modelError.ip = 'requiredIpAddress'
      }

      if (this.ipList) {
        this.ipList.forEach(item => {
          if (this.model.name && item.name === this.model.name) {
            this.modelError.name = 'existName'
          }
          if (this.model.ip && item.ip === this.model.ip) {
            this.modelError.ip = 'existIp'
          }
        })
      }

      if (!this.modelError.ip && !isValidIpAddress(this.model.ip)) {
        this.modelError.ip = 'diffFormat'
      }

      if (this.modelError.name || this.modelError.ip) return false

      let param = {
        ...this.model,
        sid: this.domains.currentDomainSid,
        siteCode: this.domains.currentSiteCode,
        domain: this.domains.selectedValue
      }
      insertIp(param).then(() => {
        this.model.name = ''
        this.model.ip = ''
        this.getDomainIpList()
      })
    },
    onRemoveIpListItem (item) {
      openDialog('userInfo.ipBlockItemDelete').then(result => {
        if (result) {
          let id = { id: item.id }
          removeIp(id).then(() => {
            this.getDomainIpList()
          })
        }
      })
    },
    onEditListItem (data) {
      let param = {
        id: data.item.id,
        name: data.model.name,
        ip: data.model.ip
      }
      openDialog('userInfo.ipBlockConfirmEdit').then(result => {
        if (result) {
          updateIp(param).then(() => {
            data.item.edit = false
            this.getDomainIpList()
          })
        }
      })
    }
  },
  created () {
    this.getDomains()
  }
}

</script>

<style lang="scss" scoped="scoped">
.ip-block__content {
  position: relative;
  float: left;
  width: calc(100% - 211px);
  margin-top: 40px;
  box-sizing: border-box;

  .content__header {
    font-size: 26px;
    font-weight: bold;
    color: #444444;
    margin-left: 30px;
    margin-right: 30px;
    padding-bottom: 22px;
    border-bottom: 1px solid #d7d7d7;

    h2 {
      padding-left: 10px;
    }
  }

  .content__body {
    height: calc(100vh - 166px);
    padding: 30px 30px 0;
    overflow-y: auto;

    &.no-register-page {
      padding-top: 0;
      margin: 212px auto 0;
      text-align: center;

      .title {
        font-size: 20px;
        font-weight: bold;
        line-height: 1;
        color: #2f2f2f;
        margin-top: 15px;
      }
      .desc {
        font-size: 14px;
        line-height: 1;
        color: #767676;
        margin-top: 15px;
      }

      .loading {
        margin-top: -53px;
      }
    }

    .content__target-domain,
    .content__target-ip {
      margin: 0 auto;
      box-sizing: border-box;
    }

    .title {
      font-size: 15px;
      font-weight: bold;
      line-height: 1.47;
      color: #2f2f2f;
    }

    .label {
      font-size: 13px;
      font-weight: bold;
      color: #767676;
      display: block;
      text-align: left;
      padding-left: 6px;
    }

    .content__target-domain {
      .form--wrap {
        @include flexXbetween;
        align-items: center;
        padding: 10px 0 15px 0;
      }
      padding: 35px 40px;

      .title {
        margin-top: 5px;
        max-width: 180px;
      }

      .domain--wrap {
        width: 530px;
        /deep/ .ui_select {
          margin-top: 5px;
          width: 100%;
        }
      }
    }

    .content__target-ip {
      margin-top: 30px;

      & > [class*=content__] {
        box-sizing: border-box;
      }

      input[type=text] {
        width: 100%;
        height: 38px;
        line-height: 14px;
        vertical-align: middle;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        padding-left: 12px;
        padding-right: 40px;
        box-sizing: border-box;
        font-size: 14px;
        margin-top: 5px;

        &:focus {
          border-color: #289eef;
        }

        &::placeholder {
          font-family: system-ui;
        }

        &.error {
          border-color: $errorColor;
        }
      }

      .validation-text {
        @include validErrorText;
        position: absolute;
        left: 6px;
        bottom: -17px;
      }

      .icon--close14 {
        position: absolute;
        top: calc(50% + 9px);
        right: 2px;
        padding: 9px 12px;
        background-position: center;
        background-color: transparent;
        transform: translateY(-50%);
      }

      .content__top {
        padding: 48px 40px 30px;
        border-bottom: 1px solid #d8d8d8;

        .input--wrap {
          margin-top: 40px;
          @include flexXbetween;
          align-items: center;

          .desc {
            max-width: 160px;
            font-size: 12px;
            line-height: 1.5;
            color: $brandColor;
          }

          .ip-info-box {
            display: flex;
          }

          .ip-name {
            position: relative;
            display: inline-block;
            width: 335px;
          }

          .ip-address {
            position: relative;
            display: inline-block;
            width: 190px;
            margin-left: 5px;
          }
        }
        .button--wrap {
          @include flexYcenter;
          justify-content: flex-end;
          margin-top: 40px;

          .btn__add-my-ip {
            font-size: 14px;
            font-weight: bold;
            line-height: 1;
            color: #444444;
            margin-right: 15px;

            .icon {
              vertical-align: text-top;
              margin-right: 8px;
            }
          }
        }
      }
      .content__bottom {
        padding: 20px 25px 30px;

        table {
          font-size: 13px;
          line-height: 1.23;
          width: 100%;

          thead tr {
            height: 50px;
            background-color: #555555;

            th {
              position: relative;
              color: #ffffff;
              text-align: left;
              padding: 0 10px;

              &:nth-of-type(1):before {
                content: "";
                display: inline-block;
                width: 10px;
                height: 50px;
                position: absolute;
                top: 0;
                left: -5px;
                background-color: #555;
                border-radius: 5px;
              }

              &:nth-last-of-type(1):after {
                content: "";
                display: inline-block;
                width: 10px;
                height: 50px;
                position: absolute;
                top: 0;
                right: -5px;
                background-color: #555;
                border-radius: 5px;
              }
            }
          }
          tbody tr {
            height: 50px;
            border-bottom: 1px solid #ebebeb;
            box-sizing: border-box;

            &.no-ip-list {
              text-align: center;
            }

            td {
              font-size: 13px;
              line-height: 1.23;
              color: #2f2f2f;
              padding: 0 10px;

              .input--wrap {
                position: relative;
                display: inline-block;
                input[type=text] {
                  width: 157px;
                  margin-top: 0;
                }
                .icon--close14 {
                  top: 50%;
                }
              }

              &.data__ip-name {
                padding-left: 10px;
              }

              &.data__ip-address {
                text-align: left;
              }

              &.data__function {
                text-align: right;

                /deep/ .ui-btn {
                  box-sizing: border-box;
                  min-width: 0;
                  width: 34px;
                  height: 34px;

                  &:nth-last-of-type(1) {
                    margin-left: 5px;
                  }

                  .icon {
                    @include positionXYcenter;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
